import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
  }

  // Si la contraseña es temporal y no estamos ya en la página de cambio → redirigir
  const mustChange = authService.currentUser()?.mustChangePassword;
  if (mustChange && state.url !== '/cambiar-contrasena') {
    return router.createUrlTree(['/cambiar-contrasena']);
  }

  return true;
};
